import { TrendingUp, TrendingDown, ShieldCheck, Clock } from "lucide-react";
import { memo } from "react";
import { formatCurrency } from "@/config/locale";
import { t } from "./wallet-i18n";

interface QuickStatsProps {
  totalReceivables: number;
  totalPayables: number;
  /** Escrow amount ("Em garantia") — unreleased seller balance. Shown between A Pagar and Pendentes. */
  escrowCents?: number;
  pendingCount: number;
  showBalance: boolean;
}

export const QuickStats = memo(function QuickStats({
  totalReceivables,
  totalPayables,
  escrowCents = 0,
  pendingCount,
  showBalance,
}: QuickStatsProps) {
  const escrow = escrowCents / 100;
  const labelClass =
    "text-xs text-muted-foreground mb-1 whitespace-nowrap leading-tight tracking-tight";
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 px-4 mb-6">
      <div className="bg-card rounded-xl p-3 sm:p-4 border border-border min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center shrink-0">
            <TrendingUp className="w-4 h-4 text-green-600" />
          </div>
        </div>
        <p className={labelClass}>{t("toReceive")}</p>
        <p className="text-sm font-bold text-green-600">
          {showBalance ? formatCurrency(totalReceivables) : "R$ •••"}
        </p>
      </div>

      <div className="bg-card rounded-xl p-3 sm:p-4 border border-border min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center shrink-0">
            <TrendingDown className="w-4 h-4 text-red-600" />
          </div>
        </div>
        <p className={labelClass}>{t("toPay")}</p>
        <p className="text-sm font-bold text-red-600">
          {showBalance ? formatCurrency(totalPayables) : "R$ •••"}
        </p>
      </div>

      <div className="bg-card rounded-xl p-3 sm:p-4 border border-border min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center shrink-0">
            <ShieldCheck className="w-4 h-4 text-amber-600" />
          </div>
        </div>
        <p className={labelClass}>{t("inEscrow")}</p>
        <p className="text-sm font-bold text-amber-600">
          {showBalance ? formatCurrency(escrow) : "R$ •••"}
        </p>
      </div>

      <div className="bg-card rounded-xl p-3 sm:p-4 border border-border min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center shrink-0">
            <Clock className="w-4 h-4 text-amber-600" />
          </div>
        </div>
        <p className={labelClass}>{t("pendingCount")}</p>
        <p className="text-sm font-bold text-amber-600">{pendingCount}</p>
      </div>
    </div>
  );
});